import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '@app/services';

import { ReservationDetails, Review, ReviewKind } from '../../models';
import { ReviewEditorComponent } from '../review-editor/review-editor.component';
import { NgbModal, NgbModalRef, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: "composition-modal",
    templateUrl: "./composition-modal.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReviewEditorComponent, NgbModalModule]
})
export class CompositionModalComponent {
  private readonly _componentName = 'CompositionModalComponent';

  @Input() reservation: ReservationDetails;
  @Input() readonly = false;
  @Input() kind: ReviewKind;
  @Output() save = new EventEmitter<Review>();
  @Output() cancel = new EventEmitter<Review>();

  /**
   * Review property
   */

  private _review: Review;
  public get review(): Review {
    return this._review;
  }

  @Input()
  public set review(v: Review) {
    console.log(`${this._componentName} review set =`, v);
    this._review = v;
    this.changeDetector.detectChanges();
  }

  constructor(private notify: NotificationService, private changeDetector: ChangeDetectorRef, private modalService: NgbModal) {}

  mode: 'create' | 'read' | 'update' = 'create';
  
  @ViewChild('modalDiv') modalDiv: TemplateRef<any>;
  modal: NgbModalRef;

  async openReadonly(review: Review) {
    this.readonly = true;
    this.mode = 'read';
    this.review = { ...review };
    this.kind = review.kind;
    this.modal = this.modalService.open(this.modalDiv);
  }

  async openEdit(review: Review) {
    this.readonly = false;
    this.mode = 'update';
    this.review = { ...this.review, ...review };
    this.modal = this.modalService.open(this.modalDiv);
    this.kind = review.kind;
  }

  async openCreate(reviewKind: ReviewKind) {
    this.mode = 'create';
    this.review = this.reservation && this.reservation.reviewFromLandowner ? this.reservation.reviewFromMember : ({} as Review);
    this.review = {
      ...this.review,
      reservationId: this.reservation.reservationId
    };
    this.review.kind = reviewKind;
    this.modal = this.modalService.open(this.modalDiv);
  }

  async onSave(review: Review) {
    this.save.emit(review);
    await this.modal.close();
  }

  get title() {
    switch (this.kind) {
      case ReviewKind.FromLandowner:
        return this.reservation.renter && `${this.reservation.renter.firstName} ${this.reservation.renter.lastName}`;
      case ReviewKind.FromMember:
        return this.reservation.listing && this.reservation.listing.title;
    }
  }
}
